import { render, staticRenderFns } from "./jobDetails.vue?vue&type=template&id=72d718b0&scoped=true&"
import script from "./jobDetails.vue?vue&type=script&lang=js&"
export * from "./jobDetails.vue?vue&type=script&lang=js&"
import style0 from "./jobDetails.vue?vue&type=style&index=0&id=72d718b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d718b0",
  null
  
)

export default component.exports